<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-actions class="justify-center">
      <v-btn :to="linkPath" color="accent"> Go </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "dashboard-link.vue",
  props: {
    title: String,
    linkPath: String,
  },
};
</script>

<style scoped></style>
